module.exports = __webpack_public_path__ + "img/strategic-2.4c501e39.png";